// Product Carousel pac - Optimized JavaScript with Multiple Instances Support
(function() {
  'use strict';
  
  // Global settings storage for multiple instances
  window.pacCarouselInstances = window.pacCarouselInstances || {};
  
  function initializeAllCarousels() {
    const carousels = document.querySelectorAll('.pac-product-carousel');
    
    if (carousels.length === 0) return;
    
    // Check if jQuery and Slick are available
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      setTimeout(initializeAllCarousels, 50);
      return;
    }
    
    const $ = window.jQuery;
    
    // Initialize each carousel instance
    carousels.forEach((carousel, index) => {
      const instanceId = `pac-carousel-${index}`;
      carousel.setAttribute('data-pac-instance', instanceId);
      
      // Get settings for this specific instance
      const container = carousel.closest('.pac-product-carousel-section');
      const sectionId = container?.id || `section-${index}`;
      
      // Use global settings or default settings
      const instanceSettings = window.pacCarouselInstances[sectionId] || window.productCarouselSettings || {};
      
      initializeSingleCarousel($, carousel, instanceSettings, instanceId);
    });
  }
  
  function initializeSingleCarousel($, carousel, settings, instanceId) {
    // Auto slider settings
    const autoplaySpeed = settings?.autoplay_speed || 5000;
    const autoplayEnabled = settings?.autoplay !== false; // Default true
    
    // Destroy existing slick instance if any
    if ($(carousel).hasClass('slick-initialized')) {
      $(carousel).slick('unslick');
    }
    
    // Initialize slick slider with autoplay
    $(carousel).slick({
      dots: settings?.show_dots !== false, // Default true
      infinite: true,
      speed: 300,
      slidesToShow: settings?.slides_to_show_desktop || 4,
      slidesToScroll: 1,
      arrows: settings?.show_arrows !== false, // Default true
      adaptiveHeight: false,
      waitForAnimate: false,
      useTransform: true,
      cssEase: 'ease',
      autoplay: autoplayEnabled,
      autoplaySpeed: autoplaySpeed,
      pauseOnHover: true,
      pauseOnFocus: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: settings?.slides_to_show_tablet || 3,
            dots: settings?.show_dots_mobile !== false,
            arrows: settings?.show_arrows !== false,
            autoplay: autoplayEnabled,
            autoplaySpeed: autoplaySpeed
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: settings?.slides_to_show_mobile || 2,
            arrows: settings?.show_arrows_mobile !== false, // Mobile me arrows enable
            dots: settings?.show_dots_mobile !== false,
            adaptiveHeight: false,
            autoplay: autoplayEnabled,
            autoplaySpeed: autoplaySpeed
          }
        }
      ]
    });
    
    // Initialize tooltips for this instance only
    const wishlistButtons = carousel.querySelectorAll('.js-btn-wishlist');
    if (wishlistButtons.length > 0 && typeof $('[data-toggle="tooltip"]').tooltip === 'function') {
      $(wishlistButtons).tooltip();
    }
    
    // Simple wishlist functionality for this instance
    $(carousel).find('.js-btn-wishlist').on('click', function(e) {
      e.preventDefault();
      const productHandle = $(this).data('handle');
      const wishlistBtn = $(this);
      
      // Simple visual feedback
      wishlistBtn.find('svg').css('color', 'red');
      wishlistBtn.attr('data-original-title', 'Added to wishlist');
      
      // Add your actual wishlist logic here
      if (typeof window.addToWishlist === 'function') {
        window.addToWishlist(productHandle);
      }
    });
    
    console.log(`pac Carousel initialized: ${instanceId}`);
  }
  
  // Initialize when DOM is ready
  function init() {
    // Wait a bit for any dynamic content to load
    setTimeout(initializeAllCarousels, 100);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Export function for re-initialization if needed
  window.reinitializepacCarousels = function() {
    initializeAllCarousels();
  };
  
  // Support for Shopify section reloads
  if (typeof window.addEventListener === 'function') {
    window.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.pac-product-carousel')) {
        setTimeout(initializeAllCarousels, 100);
      }
    });
    
    window.addEventListener('shopify:section:unload', function(event) {
      const carousel = event.target.querySelector('.pac-product-carousel');
      if (carousel && typeof window.jQuery !== 'undefined' && window.jQuery.fn.slick) {
        window.jQuery(carousel).slick('unslick');
      }
    });
  }
})();